import request from "@/utils/request";

/**获取系统单页 */
export function pageIndex(data) {
  return request({
    url: "/api/v1/6489408b9b421",
    method: "post",
    data,
  });
}

/**运营地区列表 */
export function postRegion(data) {
  return request({
    url: "/api/v1/692eb3057b03e",
    method: "post",
    data,
  });
}

/**获取配置 */
export function postGetconf(data) {
  return request({
    url: "/api/v1/65571047446d4",
    method: "post",
    data,
  });
}

/**获取用户信息 */
export function getUserInfo(data) {
  return request({
    url: "/api/v1/6486f3c53f10f",
    method: "post",
    data,
  });
}

/**根据分类获取技术详情页 */
export function getTechnologyInfo(data) {
  return request({
    url: "/api/v1/6a83ddee5daff",
    method: "post",
    data,
  });
}

/**行政区划联动 */
export function getRegionList(data) {
  return request({
    url: "/api/v1/6a87fe0549bc6",
    method: "post",
    data,
  });
}

/**获取当前经纬度 */
export function getIpLocation() {
  return request({
    url: "/api/v1/6a8c048be1325",
    method: "post",
  });
}

/**服务中心页面内容 */
export function getServiceCenter() {
  return request({
    url: "/api/v1/6a8c0f92b1665",
    method: "post",
  });
}

/**车型参数对比 */
export function getParameterCompare(data) {
  return request({
    url: "/api/v1/6a87b6fa1c775",
    method: "post",
    data,
  });
}

/**获取某个车型可用的金融产品和分期期限 */
export function getCalculatorOptions(data) {
  return request({
    url: "/api/v1/6a88107cbb4ad",
    method: "post",
    data,
  });
}

/**金融试算 */
export function getCalculate(data) {
  return request({
    url: "/api/v1/6a8810b80ed8f",
    method: "post",
    data,
  });
}

/**修改用户信息 */
export function postEditUserInfo(data) {
  return request({
    url: "/api/v1/6486cc08551d6",
    method: "post",
    data,
  });
}

/**预约试驾页面底部“试驾体验与服务”板块 */
export function getPageContent() {
  return request({
    url: "/api/v1/6a8eb1174f7e5",
    method: "post",
  });
}